import React, { Fragment } from 'react';
import { translate } from 'react-i18next';
import './speaker.css';
import Speaker1 from '../../image/conf/speaker/Prof LIN.jpg';
import Speaker2 from '../../image/conf/speaker/Peter Wong.jpg';
import Speaker3 from '../../image/conf/speaker/Mr Edmond Yu.jpg';
import Speaker4 from '../../image/conf/speaker/Mr Yin Shi.jpg';
import Speaker5 from '../../image/conf/speaker/Brian Cheng_Photo.jpg';
import Speaker6 from '../../image/conf/speaker/Mr Tao Tan.jpg';
// import Speaker7 from '../../image/conf/speaker/speaker_BU_SamsonTai.jpg';
// import Speaker8 from '../../image/conf/speaker/speaker_polyu_DanWang.jpg';
// import Speaker9 from '../../image/conf/speaker/speaker_HKSTP_Crystal.jpg';
// import Speaker10 from '../../image/conf/speaker/speaker_Huawei_DrJiaZen.jpg';
// import Speaker11 from '../../image/conf/speaker/speaker_IBM_ArunVishwanath.jpg';
// import Speaker12 from '../../image/conf/speaker/speaker_Annex 81_Stephen.jpg';
// import Speaker13 from '../../image/conf/speaker/speaker_microsoft.jpg';
// import Speaker14 from '../../image/conf/speaker/speaker_PacificNorthwest_DrDragunaVrabie.jpg';
// import Speaker15 from '../../image/conf/speaker/speaker_PropTechAllianceAndrew.jpg';
// import Speaker16 from '../../image/conf/speaker/speaker_SchindlerAufzuge_DennisBrosi.jpg';
// import Speaker17 from '../../image/conf/speaker/speaker_Siemens_DrChengFeng.jpg';
// import Speaker18 from '../../image/conf/speaker/speaker_Tencent_WanChao.jpg';
// import Speaker19 from '../../image/conf/speaker/speaker_CIBSE_KevinKelly.jpg';
// import Speaker20 from '../../image/conf/speaker/CIBSE_Ruth.jpg';
// import Speaker21 from '../../image/conf/speaker/speaker_HKChinaGas_CheungPakKin.jpg';
// import Speaker22 from '../../image/conf/speaker/speaker_Veolia_SamiraFazlollahi.jpg';
// import Speaker23 from '../../image/conf/speaker/speaker_WorldGBC_CristinaGamboa.jpg';
// import Speaker24 from '../../image/conf/speaker/speaker_WSP_WanAlexChiNga.jpg';
// import Speaker25 from '../../image/conf/speaker/speaker_DrDing.jpg';
// import Logo1 from '../../image/conf/speaker/speakers_logos_AWS.jpg';
// import Logo2 from '../../image/conf/speaker/speakers_logos_Atal.jpg';
// import Logo3 from '../../image/conf/speaker/speakers_logos_Ashrae_bac.jpg';
// import Logo4 from '../../image/conf/speaker/speakers_logos_coloradoSch.jpg';
// import Logo5 from '../../image/conf/speaker/speakers_logos_GUT.jpg';
// import Logo6 from '../../image/conf/speaker/speakers_logos_Harbin.jpg';
// import Logo7 from '../../image/conf/speaker/speakers_logos_HKBU.jpg';
// import Logo8 from '../../image/conf/speaker/speakers_logos_POLYU.jpg';
// import Logo9 from '../../image/conf/speaker/speakers_logos_HKSTP.jpg';
// import Logo10 from '../../image/conf/speaker/speakers_logos_HUAWEI.jpg';
// import Logo11 from '../../image/conf/speaker/speakers_logos_IBM.jpg';
// import Logo12 from '../../image/conf/speaker/speakers_logos_Annex.jpg';
// import Logo13 from '../../image/conf/speaker/speakers_logos_Microsoft.jpg';
// import Logo14 from '../../image/conf/speaker/speakers_logos_Pacific.jpg';
// import Logo15 from '../../image/conf/speaker/speakers_logos_PropTech.jpg';
// import Logo16 from '../../image/conf/speaker/speakers_logos_JardineSchindler.jpg';
// import Logo17 from '../../image/conf/speaker/speakers_logos_SIEMENS.jpg';
// import Logo18 from '../../image/conf/speaker/speakers_logos_Tencent.jpg';
// import Logo19 from '../../image/conf/speaker/speakers_logos_CIBSE.jpg';
// import Logo20 from '../../image/conf/speaker/speakers_logos_CIBSE.jpg';
// import Logo21 from '../../image/conf/speaker/speakers_logos_Towngas.jpg';
// import Logo22 from '../../image/conf/speaker/speakers_logos_Veolia.jpg';
// import Logo23 from '../../image/conf/speaker/speakers_logos_WGBC.jpg';
// import Logo24 from '../../image/conf/speaker/speakers_logos_WSP.jpg';
// import Logo25 from '../../image/conf/speaker/speakers_logos_ZUAE.jpg';
import Exit from '../../image/conf/btn_Exit.png';
// import say_play_btn from '../../image/home/say_play_btn.png';

const speakers = [
    {
        avatar: Speaker1,
        // logo: Logo1,
        videoSrc:
            'https://storage.googleapis.com/emsd_video/9_0915_0900_Dr%20Youngchoon%20Park_Sub.mp4',
    },
    {
        avatar: Speaker2,
        // logo: Logo2,
        videoSrc:
            'https://storage.googleapis.com/emsd_video/7_0927_0930_ATAL_Sub_2.mp4',
    },
    {
        avatar: Speaker3,
        // logo: Logo3,
        videoSrc:
            'https://storage.googleapis.com/emsd_video/5_0909_2100_Steven%20T%20Bushby_Sub_3.mp4',
    },
    {
        avatar: Speaker4,
        // logo: Logo4,
        videoSrc:
            'https://storage.googleapis.com/emsd_video/1_0902_2300_Gabe_Sub_2.mp4',
    },
    {
        avatar: Speaker5,
        // logo: Logo5,
        videoSrc:
            'https://storage.googleapis.com/emsd_video/14_ChenGuanSheng_GuangdongUniversity.mp4',
    },
    {
        avatar: Speaker6,
        // logo: Logo6,
        videoSrc:
            'https://storage.googleapis.com/emsd_video/other_Lu_Wenjie_Sub.mp4',
    },
    // {
    //     avatar: Speaker7,
    //     logo: Logo7,
    //     videoSrc: 'https://storage.googleapis.com/emsd_video/8_HKSTP_Samson_Presentation_Sub.mp4',
    // },
    // {
    //     avatar: Speaker8,
    //     logo: Logo8,
    //     videoSrc: 'https://storage.googleapis.com/emsd_video/6_HKSTP_Dan_Presentation_Sub.mp4',
    // },
    // {
    //     avatar: Speaker9,
    //     logo: Logo9,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/2_HKSTP_Crystal_Presentation_Sub_2.mp4',
    // },
    // {
    //     avatar: Speaker10,
    //     logo: Logo10,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/8_Zeng%20Jia_Huawei.mp4',
    // },
    // {
    //     avatar: Speaker11,
    //     logo: Logo11,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/3_0913_0930_Arun%20Vishwanath_Sub.mp4',
    // },
    // {
    //     avatar: Speaker12,
    //     logo: Logo12,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/6_0910_1400_Stephen%20White_Sub_2.mp4',
    // },
    // {
    //     avatar: Speaker13,
    //     logo: Logo13,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/4_0930_1100_Microsoft_Sub.mp4',
    // },
    // {
    //     avatar: Speaker14,
    //     logo: Logo14,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/9_0917_0730_Dr%20Vrabie_Sub.mp4',
    // },
    // {
    //     avatar: Speaker15,
    //     logo: Logo15,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/4_HKSTP_Andrew_Presentation_Sub.mp4',
    // },
    // {
    //     avatar: Speaker16,
    //     logo: Logo16,
    //     videoSrc:
    //         '',
    // },
    // {
    //     avatar: Speaker17,
    //     logo: Logo17,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/10_0917_1500_Dr%20Cheng%20Feng_Sub_2.mp4',
    // },
    // {
    //     avatar: Speaker18,
    //     logo: Logo18,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/7_WanChao_Tencent.mp4',
    // },
    // {
    //     avatar: Speaker19,
    //     logo: Logo19,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/13_Kevin_Kelly_CIBSE_Sub.mp4',
    // },
    // {
    //     avatar: Speaker20,
    //     logo: Logo20,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/other_Ruth_Carter_Sub_3.mp4',
    // },
    // {
    //     avatar: Speaker21,
    //     logo: Logo21,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/2_0929_0930_Towngas_Sub_3.mp4',
    // },
    // {
    //     avatar: Speaker22,
    //     logo: Logo22,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/5_0902_0900_Samira_Sub_2.mp4',
    // },
    // {
    //     avatar: Speaker23,
    //     logo: Logo23,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/3_0909_1600_Cristina_Sub.mp4',
    // },
    // {
    //     avatar: Speaker24,
    //     logo: Logo24,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/12_0930_1000_WSP_Sub_3.mp4',
    // },
    // {
    //     avatar: Speaker25,
    //     logo: Logo25,
    //     videoSrc:
    //         'https://storage.googleapis.com/emsd_video/15_Dr.DingLiHeng.mp4',
    // },
];
class Speaker extends React.Component {
    handleATag(e) {
        e.preventDefault();
    }

    updateVideo(videoSrc) {
        let video = document.getElementById('video');

        video.setAttribute(
            'src',
            videoSrc + '?autoPlay=1&amp;modestbranding=1&amp;showinfo=0'
        );
    }

    render() {
        const { t } = this.props;
        const row = this.props.row;

        // Array or array of speakers
        const groupedSpeakers = [];
        for (let i = 0; i < speakers.length; i += row) {
            groupedSpeakers.push(speakers.slice(i, i + row));
        }

        return (
            <div id='speakers'>
                <h2 className="w-100 text-center py-5 primary">
                    {t('conf-speaker-headline')}
                </h2>
                <div className='conf-speaker-desc text-center'>
                    {t('conf-speaker-desc')}
                </div>
                {groupedSpeakers.map((group, groupRow) => (
                    <Fragment key={groupRow}>
                        <div className='container-fluid d-flex justify-content-center'>
                            <div className='col-12 col-xl-10'>
                                <div className='py-4 d-flex'>
                                    {group.map((item, groupColumn) => {
                                        const index = groupRow * row + groupColumn + 1;
                                        const id = `conf-speaker-detail-${index}`;
                                        return (
                                            <Fragment key={id}>
                                                <div className='col-6 px-2'>
                                                    <a
                                                        className='conf-speaker-item d-block d-sm-flex'
                                                        data-bs-toggle='collapse'
                                                        href={`#${id}`}
                                                        role='button'
                                                        aria-expanded='false'
                                                        aria-controls={id}
                                                    >
                                                        <div className='conf-speaker-item-img col-12 col-sm-5 text-center'>
                                                            <img
                                                                src={
                                                                    item.avatar
                                                                }
                                                                className='img-fluid'
                                                                alt=''
                                                            ></img>
                                                            {/* <div className='d-none d-sm-block my-3'>
                                                                <a
                                                                    href={t(
                                                                        `conf-speaker-item-link-${index}`
                                                                    )}
                                                                    target='_blank'
                                                                    rel='noopener noreferrer'
                                                                >
                                                                    <img
                                                                        src={item.logo}
                                                                        className='img-fluid mx-auto d-block'
                                                                        alt=''
                                                                    ></img>
                                                                </a>
                                                            </div> */}
                                                        </div>
                                                        <div className='px-auto px-sm-3 col-12 col-sm-7 text-center text-sm-start'>
                                                            <h5 className="primary mt-2">
                                                                {t(
                                                                    `conf-speaker-item-name-${index}`
                                                                )}
                                                            </h5>
                                                            <div className="black mt-2">
                                                                {t(
                                                                    `conf-speaker-item-company-${index}`
                                                                )}
                                                            </div>
                                                            <div className="black mt-2">
                                                                {t(
                                                                    `conf-speaker-item-title-${index}`
                                                                )}
                                                            </div>
                                                        </div>
                                                        {/* <div className='d-block d-sm-none mt-4'>
                                                            <a
                                                                href={t(
                                                                    `conf-speaker-item-link-${index}`
                                                                )}
                                                                target='_blank'
                                                                rel='noopener noreferrer'
                                                            >
                                                                <img
                                                                    src={item.logo}
                                                                    className='img-fluid mx-auto d-block'
                                                                    alt=''
                                                                ></img>
                                                            </a>
                                                        </div> */}
                                                    </a>

                                                </div>
                                            </Fragment>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                        {group.map((item, groupColumn) => {
                            const index = groupRow * row + groupColumn + 1;
                            const id = `conf-speaker-detail-${index}`;

                            return (
                                <div
                                    key={id}
                                    id={id}
                                    className='collapse conf-speaker-detail-gp'
                                    aria-labelledby={id}
                                    data-bs-parent='#speakers'
                                >
                                    <div className='container-fluid'>
                                        <div
                                            className={`conf-speaker-detail-${groupColumn + 1
                                                } col-12 d-flex justify-content-center`}
                                        >
                                            <div className='col-10'>
                                                <div className='d-flex justify-content-between col-12'>
                                                    <div className='d-md-flex justify-content-between col-11 py-4'>
                                                        <div>
                                                            <h4 className="primary">
                                                                {t(
                                                                    `conf-speaker-item-name-${index}`
                                                                )}
                                                            </h4>
                                                            <div className="conf-speaker-detail-title mt-2">
                                                                {t(
                                                                    `conf-speaker-item-bio-title-${index}`
                                                                )}
                                                            </div>
                                                            <div className="conf-speaker-detail-title mt-2">
                                                                {t(
                                                                    'conf-speaker-item-topic-headline'
                                                                )}
                                                                {t(
                                                                    `conf-speaker-item-topic-${index}`
                                                                )}
                                                            </div>
                                                        </div>
                                                        {/* <div className='d-flex justify-content-center'>
                                                            <div
                                                                className={`conf-speaker-detail-video conf-speaker-detail-video-${index}`}
                                                                data-bs-toggle='modal'
                                                                data-bs-target='#myModal'
                                                                role='button'
                                                                onClick={() =>
                                                                    this.updateVideo(
                                                                        item.videoSrc
                                                                    )
                                                                }
                                                            >
                                                                <div
                                                                    className={`conf-speaker-detail-video-thumbnail conf-speaker-detail-video-thumbnail-${index} d-flex justify-content-center`}
                                                                >
                                                                    <div className='d-flex align-items-center'>
                                                                        <img
                                                                            src={
                                                                                say_play_btn
                                                                            }
                                                                            className='say_play_btn'
                                                                            alt=''
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className='conf-speaker-detail-video-play'></div>
                                                                <div className={t('conf-speaker-detail-video-text text-center TXT_bold')}>
                                                                    {t(
                                                                        'conf-speaker-video-text'
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                    <a
                                                        className='conf-speaker-item'
                                                        data-bs-toggle='collapse'
                                                        href={`#${id}`}
                                                        role='button'
                                                        aria-expanded='false'
                                                        aria-controls={id}
                                                    >
                                                        <img
                                                            src={Exit}
                                                            className='img-fluid mx-auto d-block btn-exit'
                                                            alt=''
                                                        ></img>
                                                    </a>
                                                </div>
                                                <p className='conf-speaker-detail-text'>
                                                    {t(
                                                        `conf-speaker-item-bio-${index}-1`
                                                    )}
                                                </p>
                                                <p className='conf-speaker-detail-text'>
                                                    {t(
                                                        `conf-speaker-item-bio-${index}-2`
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Fragment>
                ))}
            </div>
        );
    }
}

export default translate('translations')(Speaker);



// WEBPACK FOOTER //
// ./src/components/layout/speaker.js